// Determine login at module load for conditional menu visibility
const isLoggedIn = Boolean(
  typeof window !== "undefined" &&
  (localStorage.getItem("token") ||
    localStorage.getItem("payload") ||
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("payload")),
);

export const MenuDatas = [
  {
    label_en: "Registration",
    label_ma: "രജിസ്‌ട്രേഷൻ",
    id: 1,
    hideOnAuth: true,
    children: [
      {
        label_en: "Apply for a New Company in KSPACE Premises",
        label_ma: "കെസ്‌പെയ്‌സിൽ ഒരു പുതിയ കമ്പനി രജിസ്റ്റർ ചെയ്യുക",

        id: 11,
        show: true,
        // hideContinue: true,
        path: "/new-company/kspace",
        desc_en: `
                
        <p>Companies interested in setting up operations within KSPACE premises can register their request for:</p>
        <ul>
          <li>Built-up space</li>
          <li>Land on lease</li>
          <li>Joint venture opportunities</li>
        </ul>
        <p>Before registration, please ensure you have the following details ready in hand:</p>
        <ul>
          <li>Basic company details (name, address, website link, logo, contact details)</li>
          <li>Product details, capital investment, initial direct employment etc.</li>
          <li>Project proposal document</li>
        </ul>
      <div style="display:flex; align-items:center; justify-content:left; gap:10px; margin-top:8px;">
      <p>
          Detailed step-by-step registration guide <span class="blink-arrow">👉</span>
        </p>

        <a
          href="/registrations/Steps for Registration_New Company in KSPACE Premises.pdf"
          target="_blank"
          rel="noopener noreferrer"
          download
          aria-label="Download detailed step-by-step registration guide (PDF)"
        >
          <img src="/registrations/vscode-icons--file-type-pdf2.png" alt="PDF Icon" width="60" height="60" />
        </a>

      </div>
      `,
        title_en:
          "Register Your Request to Establish a New Company in KSPACE Premises",
        title_ma: "പുതിയ കമ്പനി രജിസ്റ്റർ ചെയ്യുക",
        desc_ma: `
        
        <p>കെസ്‌പെയ്‌സ് പ്രിമിസസിൽ പ്രവർത്തനങ്ങൾ സ്ഥാപിക്കാൻ താൽപര്യമുള്ള കമ്പനികൾക്ക് ഇനിപ്പറയുന്നവയ്ക്കായി അവരുടെ അഭ്യർത്ഥന രജിസ്റ്റർ ചെയ്യാം:</p>
        <ul>
          <li>നിർമ്മിത സ്ഥലം</li>
          <li>പാട്ടത്തിന് ഭൂമി</li>
          <li>ജോയിന്റ് വെഞ്ചർ അവസരങ്ങൾ</li>
        </ul>
        <p>രജിസ്ട്രേഷന് മുമ്പ്, ഇനിപ്പറയുന്ന വിശദാംശങ്ങൾ നിങ്ങളുടെ പക്കലുണ്ടെന്ന് ഉറപ്പാക്കുക:</p>
        <ul>
          <li>അടിസ്ഥാന കമ്പനി വിശദാംശങ്ങൾ (പേര്, വിലാസം, വെബ്സൈറ്റ് ലിങ്ക്, ലോഗോ, കോൺടാക്റ്റ് വിശദാംശങ്ങൾ)</li>
          <li>ഉൽപ്പന്ന വിശദാംശങ്ങൾ, മൂലധന നിക്ഷേപം, പ്രാരംഭ നേരിട്ടുള്ള തൊഴിൽ മുതലായവ.</li>
          <li>നിർദ്ദേശിച്ച പ്രോജക്റ്റ് പ്രൊപ്പോസൽ ഡോക്യുമെന്റ്</li>
        </ul>
        <div style="display:flex; align-items:center; justify-content:left; gap:10px; margin-top:8px;">
        <p>
          രജിസ്ട്രേഷന്‍റെ വിശദമായ ഘട്ടംഘട്ട ഗൈഡ് <span class="blink-arrow">👉</span>
        </p>
          <a
            href="/registrations/Steps for Registration_New Company in KSPACE Premises.pdf"
            target="_blank"
            rel="noopener noreferrer"
            download
            aria-label="രജിസ്ട്രേഷന്‍റെ വിശദമായ ഘട്ടംഘട്ട ഗൈഡ് (PDF) ഡൗൺലോഡ് ചെയ്യുക"
          >
          <img src="/registrations/vscode-icons--file-type-pdf2.png" alt="PDF Icon" width="60" height="60" />
          <span style="display:block;font-size:12px;color:#0a223d;margin-top:4px;">
            രജിസ്ട്രേഷന്‍റെ വിശദമായ ഘട്ടംഘട്ട ഗൈഡ് (ഡൗൺലോഡ്)
          </span>
        </a>
        </div>
      `,
      },
      //     {
      //       label_en: "Apply for a New Company in KSPACE Premises",
      //       label_ma: "കെസ്‌പെയ്‌സിൽ ഒരു പുതിയ കമ്പനി രജിസ്റ്റർ ചെയ്യുക",

      //       id: 11,
      //       show: true,
      //       hideContinue: true,
      //       path: "/new-company/kspace",

      //       title_en: "Register Your Request to Establish a New Company in KSPACE Premises",
      //       title_ma: "പുതിയ കമ്പനി രജിസ്റ്റർ ചെയ്യുക",

      //       desc_en: `
      //   <p><strong>The registration is temporarily closed</strong> due to system enhancement activities.</p>
      //   <p>We are working to improve our services and will reopen registrations soon.</p>
      //   <p>
      //     For more details, please contact:
      //     <a href="mailto:info@kspace.org.in">info@kspace.org.in</a>
      //   </p>
      // `,

      //       desc_ma: `
      //   <p><strong>സിസ്റ്റം മെച്ചപ്പെടുത്തൽ പ്രവർത്തനങ്ങൾ</strong> നടക്കുന്നതിനാൽ രജിസ്ട്രേഷൻ താൽക്കാലികമായി അടച്ചിരിക്കുന്നു.</p>
      //   <p>സേവനങ്ങൾ മെച്ചപ്പെടുത്തുന്നതിനുള്ള പ്രവർത്തനങ്ങളാണ് നടക്കുന്നത്. രജിസ്ട്രേഷൻ ഉടൻ തന്നെ വീണ്ടും ആരംഭിക്കും.</p>
      //   <p>
      //     കൂടുതൽ വിവരങ്ങൾക്ക് ബന്ധപ്പെടുക:
      //     <a href="mailto:info@kspace.org.in">info@kspace.org.in</a>
      //   </p>
      // `,
      //     },

      {
        label_en: "Apply for a New Company in Own Premises",
        label_ma: "കെസ്‌പെയ്‌സിൽ ഒരു പുതിയ കമ്പനി രജിസ്റ്റർ ചെയ്യുക",

        id: 11,
        show: true,
        path: "/new-company/own",
        desc_en:
          "Register your request to setup an enterprises within KSPACE.Prior to registration, ensure you have the necessary details such as area requirements and project proposal ready for upload.",
        title_en: "New company registration",
        title_ma: "പുതിയ കമ്പനി രജിസ്റ്റർ ചെയ്യുക",
        desc_ma:
          "കെസ്‌പെയ്‌സിൽ ഒരു എൻ്റർപ്രൈസസ് സജ്ജീകരിക്കുന്നതിനുള്ള നിങ്ങളുടെ അഭ്യർത്ഥന രജിസ്റ്റർ ചെയ്യുക. രജിസ്ട്രേഷന് മുമ്പ്, സ്ഥലത്തിൻ്റെ ആവശ്യകതകളും അപ്‌ലോഡ് ചെയ്യാനുള്ള പ്രോജക്റ്റ് പ്രൊപ്പോസലും നിങ്ങളുടെ പക്കലുണ്ടെന്ന് ഉറപ്പാക്കുക.",
      },
      {
        label_en: "Affiliate an Existing Aerospace Unit in Kerala with KSPACE",
        id: 12,
        show: true,
        path: "/register-kerala",
        title_en: "Registration - Affiliate your existing company with KSPACE.",
        desc_en: `
          <p>Before beginning your registration, please ensure you have the following documents and data ready.</p>
          <b>Company Details</b>
          <ul>
            <li>Name, CIN/Registration No. & Registration Certificate</li>
            <li>Registered Office Address</li>
            <li>Website & Contact person details</li>
          </ul>
          <b>Branding & Profile</b>
          <ul>
            <li>Logo (HD PNG/JPG)</li>
            <li>Brochure/Leaflet (&lt;5MB, .doc/.pdf)</li>
            <li>Short company profile</li>
          </ul>
          <b>Business Info</b>
          <ul>
            <li>Product List</li>
            <li>Domain of Activity</li>
            <li>Capital Investment, FY Turnover, FE Component (if any)</li>
          </ul>
                <div style="display:flex; align-items:center; justify-content:left; gap:10px; margin-top:8px;">
        <p>
          Detailed step-by-step registration guide <span class="blink-arrow">👉</span>
        </p>
          <a
            href="/registrations/Steps for Registration_Affiliate as an Existing Aerospace Unit.pdf"
            target="_blank"
            rel="noopener noreferrer"
            download
            aria-label="Download detailed step-by-step registration guide (PDF)"
          >
          <img src="/registrations/vscode-icons--file-type-pdf2.png" alt="PDF Icon" width="60" height="60" />
        </a>
        </div>
        `,
        desc_ma: `
          <p>രജിസ്‌ട്രേഷൻ ആരംഭിക്കുന്നതിന് മുമ്പ്, ദയവായി താഴെ പറയുന്ന രേഖകളും വിവരങ്ങളും തയ്യാറായി സൂക്ഷിക്കുക.</p>
          <h5>കമ്പനി വിശദാംശങ്ങൾ</h5>
          <ul>
            <li>പേര്, CIN/രജിസ്ട്രേഷൻ നമ്പർ & രജിസ്ട്രേഷൻ സർട്ടിഫിക്കറ്റ്</li>
            <li>റജിസ്റ്റർഡ് ഓഫീസ് വിലാസം</li>
            <li>വെബ്സൈറ്റ് & കോൺടാക്ട് വ്യക്തിയുടെ വിശദാംശങ്ങൾ</li>
          </ul>
          <h5>ബ്രാൻഡിംഗ് & പ്രൊഫൈൽ</h5>
          <ul>
            <li>ലോഗോ (HD PNG/JPG)</li>
            <li>ബ്രോഷർ/ലഘുലേഖ (&lt;5MB, .doc/.pdf)</li>
            <li>ചുരുക്കത്തിലുള്ള കമ്പനി പ്രൊഫൈൽ</li>
          </ul>
          <h5>ബിസിനസ് വിവരങ്ങൾ</h5>
          <ul>
            <li>ഉൽപ്പന്ന ലിസ്റ്റ്</li>
            <li>പ്രവർത്തന മേഖല</li>
            <li>മൂലധന നിക്ഷേപം, സാമ്പത്തിക വർഷത്തിലെ ടേൺഓവർ, വിദേശവിനിമയ ഘടകം (ഉണ്ടെങ്കിൽ)</li>
          </ul>
                <div style="display:flex; align-items:center; justify-content:left; gap:10px; margin-top:8px;">
        <p>
          Detailed step-by-step registration guide <span class="blink-arrow">👉</span>
        </p>
          <a
            href="/registrations/Steps for Registration_Affiliate as an Existing Aerospace Unit.pdf"
            target="_blank"
            rel="noopener noreferrer"
            download
            aria-label="Download detailed step-by-step registration guide (PDF)"
          >
          <img src="/registrations/vscode-icons--file-type-pdf2.png" alt="PDF Icon" width="60" height="60" />
        </a>
        </div>
        `,

        label_ma:
          "കേരളത്തിൽ നിലവിലുള്ള ഒരു എയ്റോസ്പേസ് യൂണിറ്റിനെ കെസ്പേസുമായി അഫിലിയേറ്റ് ചെയ്യുക",
        title_ma:
          " രജിസ്ട്രേഷൻ - കേരളത്തിൽ നിലവിലുള്ള ഒരു എയ്റോസ്പേസ് യൂണിറ്റിനെ കെസ്പേസുമായി അഫിലിയേറ്റ് ചെയ്യുക",
      },

      // {
      //   label_en: "Aerospace Institutions in Kerala",
      //   id: 13,
      //   show: true,
      //   path: "/register-kerala",
      //   desc_en: "Register your existing enterprises in Kerala to  KSPACE.",

      //   title_en: "Registration - Aerospace Institutions in Kerala",
      //   desc_ma:
      //     "കേരളത്തിൽ നിലവിലുള്ള നിങ്ങളുടെ സംരംഭങ്ങൾ കെസ്‌പെയ്‌സിൽ  രജിസ്റ്റർ ചെയ്യുക.",
      //   label_ma: "കേരളത്തിലെ എയ്റോസ്പേസ്  സ്ഥാപനങ്ങൾ",
      //   title_ma: " രജിസ്ട്രേഷൻ - കേരളത്തിലെ എയ്റോസ്പേസ്  സ്ഥാപനങ്ങൾ",
      // },
      // {
      //   label_en: "Existing Aerospace institutions in India with KSPACE",
      //   id: 14,
      //   show: true,
      //   path: "/register-india",
      //   desc_en: "Register your existing enterprises in India to  KSPACE.",
      //   title_en: "Registration - Aerospace Institutions in India",
      //   desc_ma:
      //     "ഇന്ത്യയിൽ  നിലവിലുള്ള നിങ്ങളുടെ സംരംഭങ്ങൾ കെസ്‌പെയ്‌സിൽ  രജിസ്റ്റർ ചെയ്യുക.",
      //   title_ma: "രജിസ്ട്രേഷൻ - ഇന്ത്യയിൽ ഒരു കമ്പനി രജിസ്റ്റർ ചെയ്യുക",
      //   label_ma:
      //     "കെസ്പേസിൽ രജിസ്റ്റർ ചെയ്യാൻ ആഗ്രഹിക്കുന്ന ഇന്ത്യയിൽ നിലവിലുള്ള എയ്റോസ്പേസ് സ്ഥാപനങ്ങൾ",
      // },
      {
        label_en: "Register Academic Institutions in Kerala with KSPACE",
        id: 17,
        show: true,
        path: "/institute-reg",
        title_en:
          "Register Your Request to Associate with KSPACE as an Academic Institution",
        desc_en: `
    <p>Academic institutions operating in Kerala are invited to register with us to explore opportunities for collaboration in research, innovation, and technology development.</p>
    <p>Through this registration, institutions can:</p>
    <ul>
      <li>Connect with industry experts, mentors, and innovators within the KSPACE network.</li>
      <li>Provide student internship and project opportunities with companies operating in the KSPACE ecosystem and many more.</li>
    </ul>
    <p>Before starting the registration process, please ensure you have the following information and documents ready:</p>
    <ul>
      <li>Basic details of your institution (name, address, contact details, logo, affiliation details, etc.)</li>
      <li>Request Letter on the official Letterhead of the Institution, duly signed by the Head/Authorized Signatory (to be uploaded in PDF format)</li>
      <li>Registration/Affiliation Certificate (to be uploaded in PDF format)</li>
    </ul>
      <div style="display:flex; align-items:center; justify-content:left; gap:10px; margin-top:8px;">
    <p>
      Detailed step-by-step registration guide <span class="blink-arrow">👉</span>
    </p>
      <a
        href="/registrations/Steps for Registration_Academic Institutions.pdf"
        target="_blank"
        rel="noopener noreferrer"
        download
        aria-label="Download detailed step-by-step registration guide (PDF)"
      >
      <img src="/registrations/vscode-icons--file-type-pdf2.png" alt="PDF Icon" width="60" height="60" />
    </a>
    </div>
  `,
        desc_ma: `
    <p>കേരളത്തിൽ പ്രവർത്തിക്കുന്ന അക്കാദമിക് സ്ഥാപനങ്ങളെ ഗവേഷണം, നവീകരണം, സാങ്കേതികവിദ്യാ വികസനം തുടങ്ങിയ മേഖലകളിൽ സഹകരണ അവസരങ്ങൾ അന്വേഷിക്കുന്നതിനായി കെസ്പേസിനൊപ്പം രജിസ്റ്റർ ചെയ്യാൻ ക്ഷണിക്കുന്നു.</p>
    <p>ഈ രജിസ്‌ട്രേഷൻ വഴി സ്ഥാപനങ്ങൾക്ക് സാധിക്കും:</p>
    <ul>
      <li>കെസ്പേസ് നെറ്റ്‌വർക്കിനുള്ളിലെ വ്യവസായ വിദഗ്ധർ, മെന്റർമാർ, നവാത്മാക്കൾ എന്നിവരുമായി ബന്ധപ്പെടാൻ.</li>
      <li>കെസ്പേസ് ഇക്കോസിസ്റ്റത്തിലുളള കമ്പനികളുമായി വിദ്യാർത്ഥികൾക്ക് ഇൻറേൺഷിപ്പ്, പ്രോജക്റ്റ് അവസരങ്ങൾ നൽകാൻ തുടങ്ങിയവ.</li>
    </ul>
    <p>രജിസ്‌ട്രേഷൻ പ്രക്രിയ ആരംഭിക്കുന്നതിന് മുമ്പ്, ദയവായി താഴെ പറയുന്ന വിവരങ്ങളും രേഖകളും തയ്യാറായി സൂക്ഷിക്കുക:</p>
    <ul>
      <li>സ്ഥാപനത്തിന്റെ അടിസ്ഥാന വിവരങ്ങൾ (പേര്, വിലാസം, ബന്ധപ്പെടാനുള്ള വിവരങ്ങൾ, ലോഗോ, അഫിലിയേഷൻ വിശദാംശങ്ങൾ തുടങ്ങിയവ)</li>
      <li>സ്ഥാപനത്തിന്റെ ഔദ്യോഗിക ലെറ്റർഹെഡിൽ തലവൻ/അധികൃത പ്രതിനിധി ഒപ്പിട്ട അഭ്യർത്ഥനാപത്രം (PDF ഫോർമാറ്റിൽ അപ്ലോഡ് ചെയ്യണം)</li>
      <li>രജിസ്‌ട്രേഷൻ/അഫിലിയേഷൻ സർട്ടിഫിക്കറ്റ് (PDF ഫോർമാറ്റിൽ അപ്ലോഡ് ചെയ്യണം)</li>
    </ul>
    <div style="display:flex; align-items:center; justify-content:left; gap:10px; margin-top:8px;">
  <p>
    Detailed step-by-step registration guide <span class="blink-arrow">👉</span>
  </p>
      <a
        href="/registrations/Steps for Registration_Academic Institutions.pdf"
        target="_blank"
        rel="noopener noreferrer"
        download
        aria-label="Download detailed step-by-step registration guide (PDF)"
      >
      <img src="/registrations/vscode-icons--file-type-pdf2.png" alt="PDF Icon" width="60" height="60" />
    </a>
    </div>
  `,
        label_ma: "KSPACE-ൽ കേരളത്തിലെ അക്കാദമിക് സ്ഥാപനങ്ങൾ രജിസ്റ്റർ ചെയ്യുക",
        title_ma:
          "കെസ്പേസിനൊപ്പം അക്കാദമിക് സ്ഥാപനമായി ചേർക്കുന്നതിനുള്ള രജിസ്ട്രേഷൻ",
      },

      {
        label_en: "Resource Personnel",
        id: 15,
        show: true,
        path: "/resource-personal-reg",

        desc_en:
          "Register your request to be part of resource pool in KSPACE.Prior to registration, ensure you have the necessary details such as educational certificates, experience certificates and photo ready for upload.",
        title_en: "Resource Personnel Registration",
        desc_ma:
          "കെസ്‌പെയ്‌സിൽ റിസോഴ്‌സ് പൂളിന്റെ ഭാഗമാകാനുള്ള നിങ്ങളുടെ അഭ്യർത്ഥന രജിസ്റ്റർ ചെയ്യുക. രജിസ്‌ട്രേഷന് മുമ്പ്, വിദ്യാഭ്യാസ സർട്ടിഫിക്കറ്റുകൾ, എക്സ്പീരിയൻസ് സർട്ടിഫിക്കറ്റുകൾ, ഫോട്ടോ എന്നിവ അപ്‌ലോഡ് ചെയ്യാൻ തയ്യാറാണെന്ന് ഉറപ്പാക്കുക.",
        title_ma: "റിസോഴ്സ് പേഴ്സണൽ രജിസ്ട്രേഷൻ",
        label_ma: "റിസോഴ്സ് പേഴ്‌സണൽ",
      },
      {
        label_en: "Expert Manpower",
        id: 16,
        show: true,
        path: "/expert-manpower-reg",
        desc_en:
          "Register your request to be part of workers registry in KSPACE.Prior to registration, ensure you have the necessary details such as educational certificates, experience certificates and photo ready for upload.",
        title_en: "Register an Expert Manpower",
        desc_ma:
          "കെസ്‌പെയ്‌സ് -ലെ തൊഴിലാളികളുടെ രജിസ്‌ട്രിയുടെ ഭാഗമാകാനുള്ള നിങ്ങളുടെ അഭ്യർത്ഥന രജിസ്റ്റർ ചെയ്യുക. രജിസ്‌ട്രേഷന് മുമ്പ്, വിദ്യാഭ്യാസ സർട്ടിഫിക്കറ്റുകൾ, എക്സ്പീരിയൻസ് സർട്ടിഫിക്കറ്റുകൾ, ഫോട്ടോ എന്നിവ അപ്‌ലോഡ് ചെയ്യാൻ തയ്യാറാണെന്ന് ഉറപ്പാക്കുക.",
        title_ma: "ഒരു എസ്പെർട് മാൻപവർ രജിസ്റ്റർ ചെയ്യുക",
        label_ma: "എസ്പെർട് മാൻപവർ",
      },
      {
        label_en: "Job Seekers",
        id: 18,
        show: true,
        path: "/candidates-reg",

        desc_en:
          "Register your request to be part of Job Seeker registry in KSPACE.Prior to registration, ensure you have the necessary details such as certificates, a copy Aadhaar/Pan/Driving Licence/Passport/Election Card ready for upload.",
        title_en: " Registration to be a part of Job Seeker Registry",
        desc_ma:
          "KSPACE-ൽ തൊഴിലന്വേഷകരുടെ രജിസ്‌ട്രിയുടെ ഭാഗമാകാനുള്ള നിങ്ങളുടെ അഭ്യർത്ഥന രജിസ്റ്റർ ചെയ്യുക. രജിസ്‌ട്രേഷന് മുമ്പ്, സർട്ടിഫിക്കറ്റുകൾ, ആധാർ/പാൻ/ഡ്രൈവിംഗ് ലൈസൻസ്/പാസ്‌പോർട്ട്/ഇലക്ഷൻ കാർഡ് എന്നിവ അപ്‌ലോഡ് ചെയ്യാൻ തയ്യാറാണെന്ന് ഉറപ്പാക്കുക.",
        title_ma: "തൊഴിലന്വേഷക രജിസ്ട്രിയുടെ ഭാഗമാകാനുള്ള രജിസ്ട്രേഷൻ",
        label_ma: "ഉദ്യോഗാർഥികൾ",
      },
      {
        label_en: "Vendors",
        id: 81,
        show: true,
        path: "/vendors-reg",
        title_en: "Vendors",
        // desc_en:
        //   "Register your request to be part of Vendors registry in KSPACE.Prior to registration, ensure you have the necessary details such as registration certificate, affiliation details and request letter ready for upload.",
        desc_en:
          "<p>🛰️ Register Your Company in the KSPACE Vendors Directory</p><p>Welcome to the Vendor Registration Portal!</p><p>To complete your registration, please keep the following ready for upload:</p><p>📌 Company Logo</p><p>📌 Company Brochure</p><p>📌 Brief Company Description</p><p><strong>💰 Tariff Plans</strong></p><p>1 Year: ₹2000 + GST</p><p>5 Years: ₹8000 + GST</p><p>A nominal service charge ensures your inclusion in the official KSPACE Vendor Directory, giving your company visibility and opportunities for collaboration.</p>",
        // "<p>\ud83d\udef0\ufe0f Register Your Company in the KSPACE Vendors Directory</p><p>Welcome to the Vendor Registration Portal!</p><p>To complete your registration, please keep the following ready for upload:</p><p>\ud83d\udccc Company Logo</p><p>\ud83d\udccc Company Brochure</p><p>\ud83d\udccc Brief Company Description</p><p><strong>\ud83d\udcb0 Tariff Plans</strong></p><p>1 Year: \u20b92000 + GST</p><p>5 Years: \u20b98000 + GST</p><p>A nominal service charge ensures your inclusion in the official KSPACE Vendor Directory, giving your company visibility and opportunities for collaboration.</p>",
        // desc_ma:
        //   "നിങ്ങളുടെ അഭ്യർത്ഥന KSPACE വെൻഡർ രജിസ്ട്രിയിൽ ഉൾപ്പെടുത്തുന്നതിനായി രജിസ്റ്റർ ചെയ്യുക. രജിസ്ട്രേഷനിന് മുമ്പ്, രജിസ്ട്രേഷൻ സർട്ടിഫിക്കറ്റ്, ബന്ധം സംബന്ധിച്ച വിശദാംശങ്ങൾ, അഭ്യർത്ഥന പത്രം എന്നിവ അപ്‌ലോഡ് ചെയ്യുന്നതിനായി തയ്യാറാക്കി വയ്ക്കുക.",
        desc_ma:
          "<p>🚀 നിങ്ങളുടെ കമ്പനി KSPACE വിൽപ്പനക്കാരുടെ ഡയറക്ടറിയിൽ രജിസ്റ്റർ ചെയ്യൂ</p> <p>വിൽപ്പനക്കാരുടെ രജിസ്ട്രേഷൻ പോർട്ടലിലേക്ക് സ്വാഗതം!</p> <p>രജിസ്ട്രേഷൻ പൂർത്തിയാക്കാൻ, താഴെ പറയുന്നവ അപ്‌ലോഡ് ചെയ്യാൻ തയ്യാറായി വെക്കുക:</p> <p>📌 കമ്പനിയുടെ ലോഗോ</p> <p>📌 കമ്പനിയുടെ ബ്രോഷർ</p> <p>📌 കമ്പനിയുടെ ചുരുക്ക വിവരണം</p> <p><strong>💰 ടാരിഫ് പ്ലാനുകൾ</strong></p> <p>1 വർഷം: ₹2000 + ജിഎസ്ടി</p> <p>5 വർഷം: ₹8000 + ജിഎസ്ടി</p> <p>ചെറിയ സർവീസ് ചാർജിലൂടെ നിങ്ങളുടെ കമ്പനി ഔദ്യോഗിക KSPACE വിൽപ്പനക്കാരുടെ ഡയറക്ടറിയിൽ ഉൾപ്പെടുന്നതാണ്. ഇതിലൂടെ നിങ്ങളുടെ കമ്പനിക്ക് ദൃശ്യപരതയും സഹകരണത്തിനുള്ള അവസരങ്ങളും ലഭിക്കും.</p>",
        title_ma: "വെൻഡേഴ്‌സ്",
        label_ma: "വെൻഡേഴ്‌സ്",
      },
    ],
  },

  {
    label_en: "Directory of Aerospace Institutions",
    label_ma: "എയ്റോസ്പേസ്  സ്ഥാപനങ്ങളുടെ ഡയറക്ടറി",

    id: 2,
    children: [
      {
        label_en: "KSPACE Premises",
        id: 21,
        show: true,
        path: "/directory-kspace",
        desc_en: "Provides the list of enterprises operating in KSPACE.",
        title_en: "Directory of Aerospace Institutions - KSPACE Premises",
        desc_ma: "കെസ്‌പെയ്‌സിൽ പ്രവർത്തിക്കുന്ന സംരംഭങ്ങളുടെ ലിസ്റ്റ്.",
        title_ma: "കേരള സ്പേസ് പാർക്ക് കമ്പനികളുടെ ഡയറക്ടറി",
        label_ma: "കെസ്‌പെയ്‌സ്",
      },
      {
        label_en: "Own Premises",
        id: 211,
        show: true,
        path: "/directory-kspace-own",
        desc_en: "Provides the list of companies operating in Own Premises.",
        title_en:
          "Directory of Companies Registered in Kspace and Working in Own Premises",
        desc_ma:
          "കെസ്പേസിനൊപ്പം രജിസ്റ്റർ ചെയ്തതും സ്വന്തം വസ്തുവിൽ (പ്രെമൈസസിൽ) പ്രവർത്തിക്കുന്നതുമായ കമ്പനികളുടെ ഡയറക്ടറി.",
        title_ma:
          "കെസ്പേസിനൊപ്പം രജിസ്റ്റർ ചെയ്തതും സ്വന്തം വസ്തുവിൽ (പ്രെമൈസസിൽ) പ്രവർത്തിക്കുന്നതുമായ കമ്പനികളുടെ ഡയറക്ടറി",
        label_ma: "കെസ്‌പെയ്‌സ്",
      },
      {
        label_en: "Kerala Companies affiliated with KSPACE",
        id: 22,
        show: true,
        path: "/directory-kerala",
        desc_en:
          "Companies operating in Aerospace / Defense / Aviation sector in Kerala and that are affiliated with KSPACE.",
        title_en: "Kerala companies affiliated with KSPACE",
        desc_ma:
          "കേരളത്തിൽ പ്രവർത്തിക്കുന്ന എയ്‌റോ (സ്‌പേസ്) സംരംഭങ്ങളുടെ ലിസ്റ്റ്.",
        title_ma: "കേരളത്തിലെ എയ്റോസ്പേസ്  സ്ഥാപനങ്ങൾ",
        label_ma: "KSPACE-മായി അഫിലിയേറ്റ് ചെയ്തിട്ടുള്ള കേരള കമ്പനികൾ",
      },

      {
        label_en: "India",
        id: 23,
        show: true,
        path: "/directory-india",
        specialPermissions: [8, 4, 5, 10, 9, 21],
        error_en: "You have to be registered to access this section",
        error_ma:
          "ഈ വിഭാഗം അക്സസ്സ് ചെയ്യുവാൻ നിങ്ങൾ റെജിസ്ട്രേഷൻ പൂർത്തിയാക്കേണ്ടതാണ്.",

        desc_en:
          "Provides the list of Aero (Space) enterprises operating in India.",
        title_en: " Directory of Aero (Space) Enterprises in India",
        desc_ma:
          "ഈ വിഭാഗം അക്സസ്സ് ചെയ്യുവാൻ നിങ്ങൾ റെജിസ്ട്രേഷൻ പൂർത്തിയാക്കേണ്ടതാണ്.",
        title_ma: "ഇന്ത്യ",
        label_ma: "ഇന്ത്യ",
      },
      {
        label_en: "International",
        id: 24,
        show: true,
        path: "/directory-international",
        specialPermissions: [8, 4, 5, 10, 9, 21],
        error_en: "You have to be registered to access this section",
        error_ma:
          "ഈ വിഭാഗം അക്സസ്സ് ചെയ്യുവാൻ നിങ്ങൾ റെജിസ്ട്രേഷൻ പൂർത്തിയാക്കേണ്ടതാണ്.",

        desc_en:
          " Provides the list of Aero (Space)enterprises operating outside India.",
        title_en: " Directory of International Aero (Space) Enterprises",
        desc_ma:
          "ഇന്ത്യയ്ക്ക് പുറത്ത് പ്രവർത്തിക്കുന്ന എയ്‌റോ (സ്‌പേസ്) സംരംഭങ്ങളുടെ ലിസ്റ്റ്.",
        title_ma: "ഇന്റർനാഷണൽ എയ്‌റോ (സ്‌പേസ്) ",
        label_ma: "ഇന്റർനാഷണൽ",
      },
      {
        label_en: "Ongoing Projects in KSPACE Premises",
        id: 21,
        show: true,
        path: "/directory-kspace/kspace",
        desc_en: "Provides the list of enterprises operating in KSPACE.",
        title_en: "Directory of Kerala Spacepark Companies",
        desc_ma: "കെസ്‌പെയ്‌സിൽ പ്രവർത്തിക്കുന്ന സംരംഭങ്ങളുടെ ലിസ്റ്റ്.",
        title_ma: "കേരള സ്പേസ് പാർക്ക് കമ്പനികളുടെ ഡയറക്ടറി",
        label_ma: "കെസ്‌പെയ്‌സ്",
      },
      {
        label_en: "Ongoing Projects in KSPACE - Own Premises",
        id: 21,
        show: true,
        path: "/directory-kspace/own",
        desc_en: "Provides the list of enterprises operating in KSPACE.",
        title_en: "Directory of Kerala Spacepark Companies",
        desc_ma: "കെസ്‌പെയ്‌സിൽ പ്രവർത്തിക്കുന്ന സംരംഭങ്ങളുടെ ലിസ്റ്റ്.",
        title_ma: "കേരള സ്പേസ് പാർക്ക് കമ്പനികളുടെ ഡയറക്ടറി",
        label_ma: "കെസ്‌പെയ്‌സ്",
      },
    ],
  },
  //others
  {
    label_en: "KSPACE Related",
    label_ma: "മറ്റുള്ളവ",
    id: 8,
    children: [
      {
        label_en: "Governing Body",
        id: 81,
        show: true,
        path: "/governing-body",
        title_en: " Governing Body",
        desc_en: "Provides KSPACE Governing Body Constitution",
        desc_ma: "കെസ്‌പെയ്‌സ് ഭരണസമിതി ലിസ്റ്റ് നൽകുന്നു.",
        title_ma: "ഭരണസമിതി",
        label_ma: "ഭരണസമിതി",
      },
      {
        label_en: "Executive Council",
        id: 81,
        show: true,
        path: "/executive-council",
        title_en: " Executive Council",
        desc_en: "Provides KSPACE Executive Council Constitution",
        desc_ma: "കെസ്‌പെയ്‌സ് എക്സിക്യൂട്ടീവ് കൗൺസിൽ ലിസ്റ്റ് നൽകുന്നു.",
        title_ma: "എക്സിക്യൂട്ടീവ് കൗൺസിൽ",
        label_ma: "എക്സിക്യൂട്ടീവ് കൗൺസിൽ",
      },
      {
        label_en: "Our Advisors",
        id: 81,
        show: true,
        path: "/advisors",
        title_en: " Our Advisors",
        desc_en: "Provides the list of KSPACE Advisory Team.",
        desc_ma: "കെസ്‌പെയ്‌സ് ഉപദേശക സംഘത്തിന്റെ ലിസ്റ്റ് നൽകുന്നു.",
        title_ma: "സ്പേസ്പാർക്ക് ഉപദേശകർ",
        label_ma: "സ്പേസ്പാർക്ക് ഉപദേശകർ",
      },

      {
        label_en: "Core Team",
        id: 81,
        show: true,
        path: "/core-team",
        title_en: " Core Team",
        desc_en: "Provides the list of KSPACE Core Team.",
        desc_ma: "കെസ്‌പെയ്‌സ് കോർ ടീം ലിസ്റ്റ് നൽകുന്നു.",
        title_ma: "കോർ ടീം",
        label_ma: "കോർ ടീം",
      },
      {
        label_en: "Events",
        id: 52,
        show: true,
        path: "/events",

        title_en: "Events",
        desc_en:
          "Provides a list of events conducted by both KSPACE & Other organizations.",
        desc_ma:
          "കെസ്‌പെയ്‌സിനൊപ്പം മറ്റ് ഓർഗനൈസേഷനുകൾ നടത്തുന്ന ഇവന്റുകളുടെ ഒരു ലിസ്റ്റ് നൽകുന്നു.",
        title_ma: "ഇവന്റുകൾ",
        label_ma: "ഇവന്റുകൾ",
      },
      {
        label_en: "Tenders",
        id: 53,
        show: true,
        path: "/tenders",
        // specialPermissions: [4, 5],
        // auth: true,
        title_en: "Tenders",
        desc_en:
          "Provides list of documents related to market studies in space sector.",
        desc_ma:
          "ബഹിരാകാശ മേഖലയിലെ മാർക്കറ്റ് പഠനങ്ങളുമായി ബന്ധപ്പെട്ട രേഖകളുടെ ലിസ്റ്റ് നൽകുന്നു.",
        title_ma: "ടെൻഡറുകൾ",
        label_ma: "ടെൻഡറുകൾ",
        error_en:
          "You don't have permission to access this section. Only KSPACE and Kerala companies have access to this section. ",
        error_ma:
          "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല. കെ.എസ്.എ.പി.എസ്, കേരള കമ്പനികൾക്ക് മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്.",
      },
      {
        label_en: "Careers",
        id: 53,
        show: true,
        path: "/careers",

        auth: true,
        title_en: "Careers",
        desc_en: " Provides the Career Opportunities in KSPACE",
        desc_ma: "കെസ്‌പെയ്‌ലെ തൊഴിലവസരങ്ങളുടെ ലിസ്റ്റ് ",

        title_ma: "തൊഴിലവസരങ്ങൾ ",
        label_ma: "തൊഴിലവസരങ്ങൾ ",
      },
      {
        label_en: "Challenges/Opportunities",
        id: 54,
        show: true,
        path: "/challenges-oppurtunities",

        auth: true,
        title_en: "Challenges/Opportunities",
        desc_en: " Provides the Challenges/Opportunities in KSPACE",
        desc_ma: "കെസ്‌പെയ്‌ലെ തൊഴിലവസരങ്ങളുടെ ലിസ്റ്റ് ",

        title_ma: "തൊഴിലവസരങ്ങൾ ",
        label_ma: "തൊഴിലവസരങ്ങൾ ",
      },
      {
        label_en: "News and Updates",
        id: 53,
        show: true,
        path: "/news",

        auth: true,
        title_en: "News and Updates",
        desc_en: " Provides a list of News and Updates",
        desc_ma: "വാർത്തകളുടെയും അപ്ഡേറ്റുകളുടെയും പട്ടിക",

        title_ma: " വാർത്തകളും അപ് ഡേറ്റുകളും ",
        label_ma: " വാർത്തകളും അപ് ഡേറ്റുകളും ",
      },
      {
        label_en: "Policies and Regulations",
        id: 53,
        show: true,
        path: "/policies",

        auth: true,
        title_en: "Policies and Regulations",
        desc_en: " Provides a list of Policies and Regulations",
        desc_ma: "നയങ്ങളുടെയും നിയന്ത്രണങ്ങളുടെയും ലിസ്റ്റ് ",

        title_ma: " നയങ്ങളും ചട്ടങ്ങളും ",
        label_ma: " നയങ്ങളും ചട്ടങ്ങളും ",
      },
      {
        label_en: "Financial Support and Incentives",
        id: 53,
        show: true,
        path: "/incentives",

        auth: true,
        title_en: "Financial Support and Incentives",
        desc_en: " Provides a list of Policies and Regulations",
        desc_ma: "നയങ്ങളുടെയും നിയന്ത്രണങ്ങളുടെയും ലിസ്റ്റ് ",

        title_ma: " നയങ്ങളും ചട്ടങ്ങളും ",
        label_ma: " നയങ്ങളും ചട്ടങ്ങളും ",
      },
      {
        label_en: "RTI",
        id: 82,
        show: true,
        path: "/contact",
        isDirect: true,
        desc_ma: "",
        title_ma: "",
        label_ma: "വിവരാവകാശം",
      },
      {
        label_en: "FAQ",
        id: 83,
        show: true,
        path: "/faq",
        isDirect: true,
        desc_ma: "",
        title_ma: "",
        label_ma: "പതിവ് ചോദ്യങ്ങൾ",
      },
    ],
  },
  //

  {
    label_en: "Directory of Resource Personnel",
    label_ma: "രജിസ്റ്റർ ചെയ്തിട്ടുള്ള റിസോഴ്സ് പേഴ്‌സണൽ  ഡയറക്ടറി",
    // specialPermissions: [4, 5, 9, 10],
    id: 4,
    children: [
      {
        label_en: "Resource Personnel",
        label_ma: "റിസോഴ്സ് പേഴ്‌സണൽ ",
        id: 41,
        // specialPermissions: [4, 5, 9, 21],
        show: true,
        path: "/resource-personal",
        // next: "/resource-personal",
        desc_en: " Provides the list of resource personnel in KSPACE.",
        title_en: "Resource Personnel",
        title_ma: "റിസോഴ്സ് പേഴ്‌സണൽ ",
        desc_ma: "കെസ്‌പെയ്‌സ്--ലെ റിസോഴ്സ് പേഴ്സണൽമാരുടെ ലിസ്റ്റ് നൽകുന്നു.",
        error_en:
          "You don't have permission to access this section. Only KSPACE Companies, Kerala Companies and Registered Personnel have access to this section. ",
        error_ma:
          "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല. കെ.എസ്.എ.പി.എസ്, കേരള കമ്പനികൾക്ക് മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്.",
      },
      {
        label_en: "Expert Manpower",
        label_ma: "എസ്പെർട് മാൻപവർ",
        id: 42,
        // specialPermissions: [4, 5, 10, 21],
        show: !isLoggedIn,
        path: "/expert-manpower",
        // next: "/expert-manpower",
        desc_en: "Provides the list of expert manpowers in KSPACE.",
        // desc_en: "Register your request to be part of workers registry in KSpace.",
        title_en: " Expert Manpower",
        title_ma: "എസ്പെർട് മാൻപവർ",
        desc_ma: "കെസ്‌പെയ്‌സ്-ലെ വിദഗ്ധരായ മനുഷ്യശക്തികളുടെ പട്ടിക നൽകുന്നു",
        error_en:
          "You don't have permission to access this section. Only KSPACE Companies, Kerala Companies and Registered Personnel have access to this section. ",
        error_ma:
          "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല. കെ.എസ്.എ.പി.എസ്, കേരള കമ്പനികൾക്ക് മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്.",
      },
      // {
      //   label_en: "Advisors",
      //   label_ma: "ഉപദേഷ്ടാക്കൾ",
      //   id: 42,
      //   specialPermissions: [4, 5, 8, 21],
      //   show: true,
      //   path: "/kspace-advisors",
      //   // next: "/expert-manpower",
      //   desc_en: "Provides the list of advisors in KSPACE.",
      //   // desc_en: "Register your request to be part of workers registry in KSpace.",
      //   title_en: " Advisors",
      //   title_ma: "ഉപദേഷ്ടാക്കൾ",
      //   desc_ma: "കെസ്‌പെയ്‌സ്-ലെ ഉപദേഷ്ടാക്കളുടെ പട്ടിക നൽകുന്നു",
      //   error_en:
      //     "You don't have permission to access this section. Only Companies and Academic Institutions have access to this section. ",
      //   error_ma:
      //     "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല. കമ്പനികൾക്കും അക്കാദമിക് സ്ഥാപനങ്ങൾക്കും മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്.",
      // },
    ],
  },
  {
    label_en: "Directory of Jobseekers",
    label_ma: "രജിസ്റ്റർ ചെയ്തിട്ടുള്ള ഉദ്യോഗാർഥികൾ",
    // specialPermissions: [4, 5, 9, 10],
    id: 4,
    children: [
      {
        label_en: "Jobseeker Profiles",
        label_ma: "ഉദ്യോഗാർത്ഥികൾ",
        id: 42,
        specialPermissions: [4, 5, 21],
        show: true,
        path: "/candidates",
        // next: "/expert-manpower",
        desc_en: "Provides the list of registered job seekers.",
        // desc_en: "Register your request to be part of workers registry in KSpace.",
        title_en: "Jobseeker Profiles",
        title_ma: "ഉദ്യോഗാർത്ഥികൾ",
        desc_ma: "രജിസ്റ്റർ ചെയ്‌തിട്ടുള്ള ഉദ്യോഗാർഥികളുടെ പട്ടിക നൽകുന്നു ",
        error_en:
          "You don't have permission to access this section. Only KSPACE Companies, Kerala Companies and Indian Companies have access to this section. ",
        error_ma:
          "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല. KSPACE, കേരള, ഇന്ത്യ  കമ്പനികൾക്ക് മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്.",
      },
      {
        label_en: "Downloaded Profiles",
        label_ma: "ഡൌൺലോഡ് ചെയ്‌ത ഉദ്യോഗാർഥികളുടെ പ്രൊഫൈലുകൾ ",
        id: 42,
        specialPermissions: [4, 5, 21],
        show: true,
        path: "/candidate-profiles",
        // next: "/expert-manpower",
        desc_en: "Provides the list of downloaded profiles of job seekers.",
        // desc_en: "Register your request to be part of workers registry in KSpace.",
        title_en: "Downloaded Profiles",
        title_ma: "ഡൌൺലോഡ് ചെയ്‌ത പ്രൊഫൈലുകൾ ",
        desc_ma:
          "ഡൌൺലോഡ് ചെയ്‌ത ഉദ്യോഗാർഥികളുടെ പ്രൊഫൈലുകളുടെ പട്ടിക നൽകുന്നു ",
        error_en:
          "You don't have permission to access this section. Only KSPACE Companies, Kerala Companies and Indian Companies have access to this section. ",
        error_ma:
          "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല. KSPACE, കേരള, ഇന്ത്യ  കമ്പനികൾക്ക് മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്.",
      },
    ],
  },
  {
    label_en: "Market Research",
    label_ma: "വിപണി ഗവേഷണം",
    id: 5,
    children: [
      {
        label_en: "Publications",
        id: 51,
        show: true,
        path: "/publications",
        desc_en:
          "Provides a repository of KSPACE publications, newsletters, journals, reports, and reference documents offering sectoral insights into the aerospace, defence, and aviation ecosystem.",
        title_en: "Publications",
        desc_ma:
          "ബഹിരാകാശം, പ്രതിരോധം, വ്യോമയാനം എന്നിവയുമായി ബന്ധപ്പെട്ട മേഖലകളിലെ അറിവുകൾ നൽകുന്ന KSPACE പ്രസിദ്ധീകരണങ്ങൾ, ന്യൂസ്‌ലെറ്ററുകൾ, ജേർണലുകൾ, റിപ്പോർട്ടുകൾ, റഫറൻസ് രേഖകൾ എന്നിവയുടെ ശേഖരം നൽകുന്നു.",
        title_ma: "പ്രസിദ്ധീകരണങ്ങൾ",
        label_ma: "പ്രസിദ്ധീകരണങ്ങൾ",
      },
      {
        label_en: "Trade Enquiries",
        id: 53,
        show: true,
        path: "/trade-enquiries",
        specialPermissions: [4, 5, 21],
        auth: true,
        title_en: "Trade Enquiries",
        desc_en:
          "Provides list of documents related to market studies in space sector.",
        desc_ma:
          "ബഹിരാകാശ മേഖലയിലെ മാർക്കറ്റ് പഠനങ്ങളുമായി ബന്ധപ്പെട്ട രേഖകളുടെ ലിസ്റ്റ് നൽകുന്നു.",
        title_ma: "വാണിജ്യ അന്വേഷണങ്ങൾ",
        label_ma: "വാണിജ്യ അന്വേഷണങ്ങൾ",
        error_en:
          "You don't have permission to access this section. Only KSPACE and Kerala companies have access to this section. ",
        error_ma:
          "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല. കെ.എസ്.എ.പി.എസ്, കേരള കമ്പനികൾക്ക് മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്.",
      },
      ,
      21,
    ],
  },
  {
    label_en: "Business Ideas",
    label_ma: "ബിസിനസ്സ് ആശയങ്ങൾ",
    id: 6,
    children: [
      {
        label_en: "Directory of Vendors",
        id: 64,
        show: true,
        // specialPermissions: [8, 4, 5, 21],
        path: "/vendor-directory",
        title_en: "Directory of Vendors",
        desc_en: "Provides the list of Vendors",
        desc_ma: "",
        title_ma: "കെസ്‌പെയ്‌സിൽ പ്രവർത്തിക്കുന്ന വെൻഡേഴ്സിന്റെ ലിസ്റ്റ്",
        label_ma: "വെൻഡേഴ്സ്",
      },
      {
        label_en: "Directory of Technology Transfer Proposals",
        id: 63,
        show: true,
        path: "/tech-transfer-proposal-list",
        // desc_en: "Register your request in  resource pool of  KSPACE to submit business ideas.",
        title_en: "Directory of Technology Transfer Proposals",
        desc_ma: "",
        specialPermissions: [4, 5, 21],
        error_en:
          "You don't have permission to access this section. Only KSPACE and Kerala companies have access to this section. ",
        error_ma:
          "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല. കെ.എസ്.എ.പി.എസ്, കേരള കമ്പനികൾക്ക് മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്.",
      },
      {
        label_en: "Submit a New Business Proposal",
        hideForAdmin: true,
        id: 61,
        show: true,
        path: "/submit-proposal",
        desc_en:
          "Register as a Resource Person of KSPACE to submit your business idea.",
        title_en: "Submit Project Proposal",
        desc_ma: "",
        title_ma: "പുതിയ പ്രൊപോസൽ സമർപ്പിക്കുക",
        label_ma: "പുതിയ പ്രൊപോസൽ സമർപ്പിക്കുക",
      },
      {
        label_en: "Directory of the Business Proposals",
        id: 62,
        show: true,
        path: "/business-proposal-list",
        // desc_en: "Register your request in  resource pool of  KSPACE to submit business ideas.",
        title_en: "Directory of the Business Proposals",
        desc_ma: "",
        title_ma: "ബിസിനസ് പ്രൊപ്പോസലിന്റെ ഡയറക്ടറി",
        label_ma: "ബിസിനസ് പ്രൊപ്പോസലിന്റെ ഡയറക്ടറി",
        specialPermissions: [4, 5, 21],
        error_en:
          "You don't have permission to access this section. Only KSPACE and Kerala companies have access to this section. ",
        error_ma:
          "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല. കെ.എസ്.എ.പി.എസ്, കേരള കമ്പനികൾക്ക് മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്.",
      },
    ],
  },

  {
    label_en: "Gallery",
    label_ma: "ഗാലറി",
    id: 7,
    children: [
      {
        label_en: "Images",
        id: 71,
        show: true,
        path: "/gallery/images",
        isDirect: true,
        desc_ma: "",
        title_ma: "",
        label_ma: "ചിത്രങ്ങൾ",
      },
      {
        label_en: "Videos",
        id: 72,
        show: true,
        path: "/gallery/video",
        isDirect: true,
        desc_ma: "",
        title_ma: "",
        label_ma: "വീഡിയോകൾ",
      },
    ],
  },
  //association with professional bodies
  {
    label_en: "Association with Professional Bodies / Institutions",
    label_ma: "പ്രഫഷണൽ ബോഡീസുമായുള്ള അസോസിയേഷൻ ",
    id: 3,
    children: [
      // {
      //   label_en: "Professional Bodies / Institutions",
      //   id: 31,
      //   show: true,
      //   path: "/professional-bodies",
      //   title_en: "Associated Professional Bodies / Institutions",
      //   desc_en:
      //     "Provides the list of KSPACE Association with Professional Bodies.",
      //   desc_ma:
      //     " പ്രൊഫഷണൽ ബോഡികളുമായുള്ള കെസ്‌പെയ്‌സ് അസോസിയേഷന്റെ ലിസ്റ്റ് നൽകുന്നു.",
      //   title_ma: "അസോസിയേറ്റഡ് പ്രൊഫഷണൽ ബോഡികൾ / സ്ഥാപനങ്ങൾ",
      //   label_ma: "പ്രൊഫഷണൽ ബോഡികൾ / സ്ഥാപനങ്ങൾ",
      // },
      {
        label_en: "Directory of Registered Academic Institutions",
        id: 32,
        show: true,

        path: "/institute-list",
        desc_en:
          "Provides the list of KSPACE collaboration with Academic Institutions",
        title_en: "Directory of Registered Academic Institutions",
        desc_ma: "",
        title_ma: "രജിസ്റ്റർ ചെയ്ത സ്ഥാപനങ്ങളുടെ ഡയറക്ടറി",
        label_ma: "രജിസ്റ്റർ ചെയ്ത സ്ഥാപനങ്ങളുടെ ഡയറക്ടറി",
      },
      {
        label_en: "Submit a Student Project Proposal",
        id: 33,
        show: true,
        // specialPermissions: [8, 21],
        path: "/proposal-submit",
        desc_en:
          "Register your request to be part of Student Project Proposal registry in KSPACE.Prior to registration, ensure you have the necessary details such as registration certificate, affiliation details and request letter ready for upload.",
        title_en: "Submit a Student Project Proposal",
        desc_ma:
          "സ്റ്റുഡന്റ് പ്രോജക്ട് പ്രൊപ്പോസൽ രജിസ്ട്രിയുടെ ഭാഗമാകാനുള്ള നിങ്ങളുടെ അഭ്യർത്ഥന KSPACE-ൽ രജിസ്റ്റർ ചെയ്യുക. രജിസ്ട്രേഷന് മുമ്പ്, രജിസ്ട്രേഷൻ സർട്ടിഫിക്കറ്റ്, അഫിലിയേഷൻ വിശദാംശങ്ങൾ, അഭ്യർത്ഥന കത്ത് തുടങ്ങിയ ആവശ്യമായ വിശദാംശങ്ങൾ അപ്‌ലോഡ് ചെയ്യാൻ തയാറാണെന്നു ഉറപ്പാക്കുക.",
        title_ma: "സ്റ്റുഡന്റ് പ്രോജക്റ്റ് പ്രൊപ്പോസൽ സമർപ്പിക്കുക",
        label_ma: "സ്റ്റുഡന്റ് പ്രോജക്റ്റ് പ്രൊപ്പോസൽ സമർപ്പിക്കുക",
      },

      {
        label_en: "Directory of Student Project Proposals",
        id: 34,
        show: true,
        specialPermissions: [8, 4, 5, 21],
        path: "/student-proposal-directory",
        title_en: "Directory of Student Project Proposal",
        desc_ma:
          "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല.കെസ്പേസിൽ രജിസ്റ്റർ ചെയ്തിട്ടുള്ള അക്കാദമിക് സ്ഥാപനങ്ങൾ, കെ.എസ്.എ.പി.എസ്, കേരള കമ്പനികൾക്ക് മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്.",
        title_ma: "വിദ്യാർത്ഥി പ്രോജക്റ്റ് പ്രൊപ്പോസലിൻറെ ഡയറക്ടറി",
        label_ma: "വിദ്യാർത്ഥി പ്രോജക്റ്റ് പ്രൊപ്പോസലിൻറെ ഡയറക്ടറി",
        error_en:
          "You don't have permission to access this section. Only Academic Institutions, KSPACE and Kerala companies have access to this section. ",
        error_ma:
          "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല.കെസ്പേസിൽ രജിസ്റ്റർ ചെയ്തിട്ടുള്ള അക്കാദമിക് സ്ഥാപനങ്ങൾ, കെ.എസ്.എ.പി.എസ്, കേരള കമ്പനികൾക്ക് മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്.",
      },
      {
        label_en: "Internship / Training Request",
        id: 35,
        show: true,
        // hideForAdmin :true,
        path: "/training-reg",
        hideContinue: true,
        // specialPermissions: [8],
        desc_en:
          // "Register your request to be part of Internship/Training registry in KSPACE.Prior to registration, ensure you have the necessary details such as registration certificate, affiliation details and request letter ready for upload.",
          "Currently, there are no internship openings available. Updates will be posted on this portal as and when new opportunities become available.",
        title_en: "Internship/Training Request",
        desc_ma:
          "നിങ്ങളുടെ അഭ്യർത്ഥന KSPACE ഇൻറേൺഷിപ്പ്/ട്രെയിനിംഗ് രജിസ്ട്രിയിലുടെ പങ്കാളിയാകാൻ രജിസ്റ്റർ ചെയ്യുക. രജിസ്ട്രേഷൻ നടത്തുന്നതിന് മുമ്പ്, രജിസ്ട്രേഷൻ സർട്ടിഫിക്കറ്റ്, അഫിലിയേഷൻ വിശദാംശങ്ങൾ, അഭ്യർത്ഥനാ കത്ത് എന്നിവ അപ്‌ലോഡ് ചെയ്യാൻ തയ്യാറായി കൈവശം ഉണ്ടെന്ന് ഉറപ്പാക്കുക.",
        title_ma: "ഇന്റേൺഷിപ്പ്/പരിശീലന അഭ്യർത്ഥന",
        label_ma: "ഇന്റേൺഷിപ്പ്/പരിശീലന അഭ്യർത്ഥന",
        // error_en:
        //   "You don't have permission to access this section. Only Academic Institutions registered with KSPACE have access to this section",
        // error_ma:
        //   "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല.കെസ്പേസിൽ രജിസ്റ്റർ ചെയ്തിട്ടുള്ള അക്കാദമിക് സ്ഥാപനങ്ങൾക്ക് മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്.",
      },
      {
        label_en: "Directory of Internships / Training Requests",
        id: 36,
        show: true,
        path: "/training-list",
        specialPermissions: [8, 4, 5, 21],
        desc_en: null,
        title_en: "Directory of Internship/Training Request",
        desc_ma: "",
        title_ma: "ഇന്റേൺഷിപ്പ്/പരിശീലന അഭ്യർത്ഥനയുടെ ഡയറക്ടറി",
        label_ma: "ഇന്റേൺഷിപ്പ്/പരിശീലന അഭ്യർത്ഥനയുടെ ഡയറക്ടറി",
        error_en:
          "You don't have permission to access this section. Only Academic Institutions and companies registered with KSPACE have access to this section.",
        error_ma:
          "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല. കെസ്പേസിൽ രജിസ്റ്റർ ചെയ്തിട്ടുള്ള അക്കാദമിക് സ്ഥാപനങ്ങൾക്കും കമ്പനികൾക്കും മാത്രമേ ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളൂ.",
      },
    ],
  },

  //
];
